import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatOutcomeCanSomeoneExpectUponCompletionOfProbatePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-outcome-can-someone-expect-upon-completion-of-probate/']} />;
}
